import React, { useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components';

import { isBrowser } from '@tager/web-core';

import { ReactComponent as Icon } from '@/assets/svg/arrow_question.svg';
import { colors } from '@/constants/theme';
import { StringFieldType } from '@/typings/common';

type Props = {
  children?: React.ReactNode;
  title: string;
  className?: string;
  activeTab?: string;
};

function DropDown({ title, children, className, activeTab }: Props) {
  const [isOpen, setOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const ref = useRef<HTMLDivElement>(null);

  const opener = () => {
    setOpen((prev) => !prev);
  };
  useEffect(() => {
    if (isBrowser() && ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  }, []);
  return (
    <Component className={className} active={isOpen} onClick={opener}>
      <Top>
        <Title
          className={`dropdown-title text-element_${
            activeTab === title ? 'highlighted' : 'hide'
          }`}
        >
          {title}
        </Title>
        <StyledIcon className="dropdown-arrow" />
      </Top>
      <ContentWrapper>
        <Content ref={ref} active={isOpen} size={height}>
          {children}
        </Content>
      </ContentWrapper>
    </Component>
  );
}

export default DropDown;

const Component = styled.div<{ active: boolean }>`
  cursor: pointer;
  & svg {
    transition: transform 0.2s ease;
  }
  ${({ active }) =>
    active &&
    css`
      & .text-element_highlighted {
        color: ${colors.primary};
      }

      & .dropdown-arrow {
        transform: rotate(-180deg);
      }

      & .dropdown-arrow path {
        fill: ${colors.primary};
      }
    `}
`;
const Title = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 30px;
`;
const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
const ContentWrapper = styled.div`
  overflow: hidden;
`;

const Content = styled.div<{ active: boolean; size: number }>`
  transition: height 0.2s ease;
  ${({ active, size }) =>
    active
      ? css`
          height: ${size}px;
        `
      : css`
          height: 0;
          margin-top: 0;
        `}
`;
const StyledIcon = styled(Icon)``;
